import { render, staticRenderFns } from "./CustomerResetPassword.vue?vue&type=template&id=ee075bd0&"
import script from "./CustomerResetPassword.vue?vue&type=script&lang=js&"
export * from "./CustomerResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports